import padding from "@irati/ui/src/global/padding"

export interface BottomPaddingProps {
  /** padding.large padding bottom */
  large?: boolean,
  /** padding.medium padding bottom */
  medium?: boolean,
  /** padding.base padding bottom */
  base?: boolean,
  /** padding.small padding bottom */
  small?: boolean,
  /** padding.tiny padding bottom */
  tiny?: boolean,
  /** 5px padding bottom */
  withBody?: boolean
}

const addBottomPadding = (props: BottomPaddingProps) => {
  if (props.large) {
    return `padding-bottom: ${padding.large};`
  } else if (props.medium) {
    return `padding-bottom: ${padding.medium};`
  } else if (props.base) {
    return `padding-bottom: ${padding.base};`
  } else if (props.small) {
    return `padding-bottom: ${padding.small};`
  } else if (props.tiny) {
    return `padding-bottom: ${padding.tiny};`
  } else if (props.withBody) {
    return "padding-bottom: 5px;"
  }

  return null
}

export default addBottomPadding
